import React from 'react';
import { PropTypes } from 'prop-types';

import NavigationItem from './NavigationItem';
import { HoverConsumer } from '../../custom-cursor';

const SectionNavigation = ({ styles, /* sectionRefs ,*/ sections, itemsVisible }) => {
    const [activeItemId, setActiveItemId] = React.useState(0);

    const sectionRefs = React.useMemo(() => Object.values(sections).map(item => item.ref), [sections]);
    const sectionTitles = React.useMemo(() => Object.values(sections).map(item => item.title), [sections]);
    const sectionIds = React.useMemo(() => Object.values(sections).map(item => item.id), [sections]);

    React.useEffect(() => {
        const sectionElements = sectionRefs.map(item => item.current);

        const observeCallback = entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    const entryIndex = sectionElements.indexOf(entry.target);
                    setActiveItemId(entryIndex);
                }
            });
        };

        const getRootMargin = () => {
            const windowHalf = window.innerHeight / 2;

            return `0px 0px -${windowHalf}px 0px`;
        };

        const options = {
            rootMargin: getRootMargin(),
        };

        const observer = new IntersectionObserver(entries => observeCallback(entries), options);

        sectionElements.forEach(section => observer.observe(section));
    }, [sectionRefs]);

    const lastIndex = React.useMemo(() => sectionRefs.length - 1, [sectionRefs]);

    return (
        <div className={styles.container}>
            <HoverConsumer>
                {render =>
                    sectionRefs.map((item, index) => (
                        <NavigationItem
                            context={render.context}
                            setContext={render.setContext}
                            reference={item}
                            title={sectionTitles[index]}
                            active={index === activeItemId}
                            key={sectionIds[index]}
                            isLast={index === lastIndex}
                            itemsVisible={itemsVisible}
                        />
                    ))
                }
            </HoverConsumer>
        </div>
    );
};

SectionNavigation.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    sections: PropTypes.PropTypes.shape().isRequired,
    itemsVisible: PropTypes.bool,
};

SectionNavigation.defaultProps = {
    itemsVisible: false,
};

export default SectionNavigation;
